<template>
    <div class="flat-index" id="wrapper">
        <div class="fi-pc aboutus-container">
            <div class="fi-main">
                <fi-header></fi-header>
                <div class="aboutus">
                    <div class="clearfix">
                        <div class="ab-title ab-l">
                            <a name="guyudd">
                                <h1>01</h1>
                                <div class="ab-text" :id="'anchor-'+0">
                                    <!-- <h2>关于点点</h2> -->
                                    <a href="#anchor-0">关于点点</a>
                                    <p>About D.Point</p>
                                </div>
                                <div class="nr">
                                    点点，是由深圳蜂点科技有限公司运营的智能生活金融服务平台，旨为用户提供优质的综合生活与金融连接服务。已与国内众多知名金融机构达成深度合作。
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="clearfix">
                        <div class="ab-title ab-l">
                            <h1>02</h1>
                            <div class="ab-text" :id="'anchor-'+1">
                                <!-- <h2>点点大事记</h2> -->
                                <a href="#anchor-1">点点大事记</a>
                                <p>About D.Point</p>
                            </div>
                            <div class="shou-icon"></div>
                        </div>
                        <div class="ab-title ab-r">
                            <div class="js-icon"></div>
                        </div>
                    </div>
                    <div class="ab-title">
                        <h1>03</h1>
                        <div class="ab-text" :id="'anchor-'+2">
                            <!-- <h2>点点愿景·一站式金融生活服务平台</h2> -->
                            <a href="#anchor-2">点点愿景·一站式金融生活服务平台</a>
                            <p>About Future·A One-stop Financial Service Platform</p>
                        </div>
                        <div class="gc-icon">
                            <ul class="clearfix">
                                <li>
                                    <i></i>
                                    <h2>金融</h2>
                                </li>
                                <li>
                                    <i></i>
                                    <h2>商城</h2>
                                </li>
                                <li>
                                    <i></i>
                                    <h2>生活服务</h2>
                                </li>
                                <li>
                                    <i></i>
                                    <h2>充值缴费</h2>
                                </li>
                                <li>
                                    <i></i>
                                    <h2>休闲娱乐</h2>
                                </li>
                                <li>
                                    <i></i>
                                    <h2>线下服务</h2>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <fi-footer></fi-footer>
        </div>
    </div>
</template>
<script>
import {
    os
} from '../utils/tool'
import FiHeader from '../components/header'
import FiFooter from '../components/footer'

export default {
    components: {
        FiHeader,
        FiFooter
    },
    data() {
        const _vue = this;
        return {
            isPc: false,
            isMobile: false,
            nowIndex: 0,
            page:6,
            isMoveing:true,
            headerText:['首页','关于我们','商务合作','帮助中心'],
            headerActive:[true],
            navText:['借点','点点商城','点点闪付','生活缴费','充值娱乐','办信用卡'],
            navActive:[true],
            isQrCode:[false,false,false],
            swiperOption: {
                // direction: 'vertical',
                // mousewheel: true,
                // parallax: true,
                // touchRatio: 0.5,
                // resistanceRatio: 0,
                speed: 450,
                height: 420,
                // autoplay: {
                //     delay: 5000
                // },
                loop: true,
                // effect: 'fade',
                // allowTouchMove: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                on: {
                    slideChange: function(e) {

                        // console.log(nowActiveIndex, this.activeIndex, 'index');
                    },
                    transitionEnd: function() {
                        if (_vue.swiperOption.autoplay) {
                            this.autoplay.start()
                        }
                    }
                }
            }
        }
    },
    created() {
        document.title = '关于我们';
    },
    mounted() {



    },
    methods: {

    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AboutUs.vue?748e1922